import React, { useState, useEffect } from "react";
import useCheckAccountExpiration from "./hooks/useCheckAccountExpiration";
import useCheckIsForushgah from "./hooks/useCheckIsForushgah";
import useGetProfileData from "./hooks/useGetProfileData";

//////////////////////////////////////////////////////////////////////////
const AppInitialize = ({ children }) => {
  useCheckAccountExpiration();
  useGetProfileData();
  useCheckIsForushgah();

  return <>{children}</>;
};

export default AppInitialize;
